import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { Paper, Box, Button, Typography, IconButton, TextField, Divider, Table, TableHead, TableBody, TableCell, TableRow } from '@mui/material';
import { Modal } from "./modal";
import { MoreVert } from '@mui/icons-material'

export default function Root(props) {
  return (
      <RootWrapped {...props} />
  )
}


interface TypeField {
  name: string;
  type: {
    name: string,
    kind: string;
    ofType?: {
      name: string;
      fields?: TypeField[];
    }
  }
}

interface InputField {
  name: string;
  type: {
    name: string,
    kind: string;
    ofType?: {
      name: string;
      inputFields?: InputField[];
    }
  }
}

export interface RootProps{
  model: {
    name: string;
    input: string;
  };

  getData: () => Promise<any[]>;
  createData: (item: any) => Promise<void>;
  updateData: (item: any) => Promise<void>;
  deleteData: (item: any) => Promise<void>;

  onSelectRow?: (row: any) => void;
}

const RootWrapped : React.FC<RootProps> = (props) => {

  // const { data: gqldata } = useQuery(gql`
  //   query ($inputType: String!, $type: String!) {
  //     inputType:__type(name:$inputType){
  //       name
  //       kind
  //       enumValues{
  //         name
  //       }
  //       inputFields {
  //         name
  //         type {
  //           name
  //           kind
  //           ofType {
  //             name
  //             kind
  //             enumValues{
  //               name
  //             }
  //             inputFields {
  //               name
  //               type {
  //                 name
  //                 kind
  //                 enumValues{
  //                   name
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }  
  // `, {
  //   variables: {
  //     inputType: 'DataModelInput'
  //   }
  // })

  // const inputFields: InputField[] = gqldata?.inputType?.inputFields || [];

  const { model, getData, createData, updateData, deleteData } = props || {};

  const [selected, setSelected] = useState<any>(null);
  const [modalOpen, openModal] = useState(false);

  const [data, setData] = useState<any[]>([]);

  const keys = ['id', 'name']
  
  useEffect(() => {
    getData?.().then((data) => {
      setData(data)
    })
  }, [getData])

  const closeModal = () => {
    openModal(false)
    setSelected(null);
  }

  return <div style={{
    minHeight: 0,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '8px'
  }}>
    <Modal
      models={data}
      model={{ name: model?.name }}
      selected={selected}
      open={modalOpen}
      onDelete={() => {
        deleteData?.(selected).then(() => {
          getData?.().then((data) => {
            setData(data)
            closeModal()
          })
        })
      }}
      onSubmit={(item) => {
        if (item.id) {
          updateData?.(item).then(() => {
            getData?.().then((data) => {
              setData(data)
              closeModal()
            })
          })
        } else {
          createData?.(item).then(() => {
            getData?.().then((data) => {
              setData(data)
              closeModal()
            })
          })
        }


      }}
      onClose={closeModal}
    />
    <Box sx={{ display: 'flex', paddingBottom: '8px', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography>{model?.name}</Typography>
      <Button onClick={() => openModal(true)} variant="contained">Add</Button>
    </Box>
    <Divider />
    <Box sx={{ flex: 1, minHeight: 0, overflow: 'scroll' }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {keys.map((key, ix) => (
              <TableCell key={`header-${ix}`}>
                {key}
              </TableCell>
            ))}
            <TableCell sx={{ width: '45px' }} padding="none"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((item, ix) => (
            <TableRow
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  background: "#dfdfdf"
                }
              }}
              key={`row-${ix}`}
              onClick={() => {
                props.onSelectRow?.(item)
              }}>
              {keys.map((key) => (
                <TableCell key={`row-${ix}-${key}`}>
                  {item[key]}
                </TableCell>
              ))}
              <TableCell sx={{ width: '45px' }} padding="none">
                <IconButton onClick={(e) => {
                  e.stopPropagation();
                  setSelected(item)
                  openModal(true)
                }}>
                  <MoreVert />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  </div>;
}
